import React, {useRef} from "react";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import {authStore} from "../../store/authStore";

const TermsOfConditions = () => {
    const ref = useRef();
    const {setTermsPopup} = authStore;

    const handleClose = () => {
        setTermsPopup("");
    };

    const openPrivacy = () => {
        setTermsPopup("privacy");
    };

    const openCookie = () => {
        setTermsPopup("cookie");
    };

    useOnClickOutside(ref, () => handleClose());
    return (
        <div className="terms-outer-body">
            <div ref={ref} className="terms-inner-body">
                <i className="icon-close" onClick={handleClose}/>
                <h1>PANDAMR TERMS AND CONDITIONS (Platform, Software, Website)</h1>
                <p>
                    Welcome to PandaMR – a metaverse platform (the <strong>"Platform"</strong>) provided via a software
                    as a service solution (the <strong>"Software"</strong>), along with <a
                    href="https://www.pandamr.com/">https://www.pandamr.com/</a> (the <strong>"Website"</strong>)
                    (together, the<strong>"Services"</strong>).
                </p>
                <p className="padding">
                    The Services are owned and operated by Soft Construct (Malta) Limited, with company number
                    C65512 whose registered office is at Luxe Pavilion, 2nd level, Diamonds International Building,
                    Portomaso, St Julian’s STJ 4010, Malta.
                </p>
                <p className="padding">
                    Your use of the Services is subject to these terms of use (<strong>"Terms"</strong>). Please read
                    them carefully
                    before using the Services. If you do not agree to these Terms, please do not use the Services.
                </p>
                <p className="padding">
                    Nothing in these Terms is intended to interfere with any rights that you may have as a consumer
                    under applicable laws where those rights cannot be overridden by contract terms.
                </p>
                <p>
                    In these Terms <strong>"we/our/us"</strong> means SoftConstruct (Malta) Limited,
                    and <strong>"you/your"</strong> means you as a
                    user of the Services.
                </p>
                <p>
                    To contact us regarding these Terms (or if you have any questions), please email us at
                    info@pandamr.com or send us a message via the 'Contact Us' page on the Website.
                </p>
                <h2>1. OUR TERMS</h2>
                <p>
                    1.1 By using the Services, you signify your agreement to be bound by these Terms. If you do not
                    accept these Terms, you should not use the Services.
                </p>
                <p>
                    1.2 We reserve the right to change these Terms at any time and you are advised to review the Terms
                    regularly to ensure that you are aware of any changes. Your continued use of the Services after such
                    changes are posted will be deemed agreement on your part to these Terms, as amended.
                </p>
                <p>
                    1.3 Please also read our <span className="underline" onClick={openPrivacy}>Privacy Policy </span>
                    and <span className="underline" onClick={openCookie}>Cookie Policy</span>, which explain how we may
                    collect and use information about you via our Services.
                </p>
                <p>
                    1.4 If you are accessing the Platform via the PandaMR web app (the "<strong>App</strong>"), please
                    read our App Terms and Conditions[RPC1] .
                </p>
                <p>
                    1.5 You agree to comply with any applicable third party terms of agreement provided to you when
                    using the Services.
                </p>
                <h2>2. ACCESSING AND USING OUR SOFTWARE</h2>
                <p>
                    2.1 In consideration of you agreeing to abide by these Terms, SoftConstruct hereby grants to you a
                    non-exclusive, non-transferable licence to use the Software on the terms set out in this section 2,
                    until terminated in accordance with these Terms (the "Licence").
                </p>
                <p className="padding">
                    2.2 You may:
                </p>
                <p>
                    2.2.1 install and use the Software for your personal purposes only
                </p>
                <p>
                    (a) on one central processing unit (CPU) if the Licence is a single-user licence or the Software is
                    for single use; or
                </p>
                <p className="padding">
                    (b) if the Licence is a multi-user or network licence, for the number of concurrent users agreed
                    between you and us.
                </p>
                <p>
                    2.2.2 make one copy of the Software for back-up purposes; and
                </p>
                <p>
                    2.2.3 receive and use any free supplementary software code or update of the Software incorporating
                    "patches" and corrections of errors as may be provided by us from time to time.
                </p>
                <p>
                    2.3 We may update or require you to update the Software, provided that the Software shall always
                    match the description of it that we provided to you.
                </p>
                <p>
                    2.4 You agree that you will:
                </p>
                <p>
                    2.4.1 not copy the Software, except where such copying is incidental to normal use of the Software
                    or where it is necessary for the purpose of back-up or operational security;
                </p>
                <p className="padding">
                    2.4.2 not rent, lease, sub-license, loan, translate, merge, adapt, vary, alter or modify, the whole
                    or any part of the Software nor permit the Software or any part of it to be combined with, or become
                    incorporated in, any other programs;
                </p>
                <p>
                    2.4.3 not disassemble, de-compile, reverse engineer or create derivative works based on the whole or
                    any part of the Software nor attempt to do any such things, except to the extent that (by virtue of
                    sections 50B and 296A of the Copyright, Designs and Patents Act 1988) such actions cannot be
                    prohibited because they are necessary to decompile the Software to obtain the information necessary
                    to create an independent program that can be operated with the Software or with another program
                    (Permitted Objective), and provided that the information obtained by you during such activities:
                </p>
                <p>
                    (a) is used only for the Permitted Objective;
                </p>
                <p>
                    (b) is not disclosed or communicated without our prior written consent to any third party to whom it
                    is not necessary to disclose or communicate it in order to achieve the Permitted Objective; and
                </p>
                <p className="padding">
                    (c) is not used to create any software that is substantially similar in its expression to the
                    Software;
                </p>
                <p>
                    2.4.4 keep all copies of the Software secure and to maintain accurate and up-to-date records of the
                    number and locations of all copies of the Software;</p>
                <p>
                    2.4.5 include our copyright notice on all entire and partial copies of the Software in any form;
                </p>
                <p>
                    2.4.6 not provide, or otherwise make available, the Software in any form, in whole or in part
                    (including, but not limited to, program listings, object and source program listings, object code
                    and source code) to any person without prior written consent from us; and
                </p>
                <p>
                    2.4.7 comply with all applicable technology control or export laws and regulations.
                </p>
                <h2>3. ACCESSING AND USING OUR WEBSITE</h2>
                <p>
                    3.1 Access to our Website is permitted on a temporary basis and we reserve the right to suspend,
                    withdraw, discontinue or change all or any part of our Website without notice. We will not be liable
                    to you if for any reason our Website is unavailable at any time or for any period.
                </p>
                <p>
                    3.2 We may update our Website from time to time, and may change the content at any time. The content
                    on our Website is provided for general information only. It is not intended to amount to advice on
                    which you should rely. You must obtain professional or specialist advice before taking, or
                    refraining from, any action on the basis of the content on our Website.
                </p>
                <p>
                    3.3 Although we make reasonable efforts to update the information on our Website, we make no
                    representations, warranties or guarantees, whether express or implied, that the content on our
                    Website is accurate, complete or up-to-date.
                </p>
                <p>
                    3.4 If we permit you to post or provide any information on or via this Website, you must ensure that
                    such information does not contravene any applicable laws or infringe any person's legal rights. We
                    do not monitor or edit documents or files posted or provided to us by third parties and accordingly
                    we do not accept any responsibility for any damage or loss you may suffer.
                </p>
                <p>
                    3.5 We reserve the right in our absolute discretion to prohibit any link from another site to
                    materials or information on our Website without notice. Any link to material or information on the
                    Website must be neither misleading nor deceptive and must fairly indicate the Website as the
                    destination of the link. You must not establish a link in such a way as to suggest any form of
                    association, approval or endorsement on our part where none exists.
                </p>
                <p>
                    3.6 You agree that you will not:
                </p>
                <p>
                    3.6.1 attempt to decompile, reverse engineer, disassemble or otherwise to derive source code from
                    the Website;
                </p>
                <p>
                    3.6.2 tamper with, hinder the operation of, make unauthorised modifications to the Website including
                    attempting to interfere with the access of any user, host or network;
                </p>
                <p>
                    3.6.3 use the Website for any activities which breach any laws or regulations or infringe any third
                    party rights;
                </p>
                <p>
                    3.6.4 remove, obscure, or alter any copyright notices, trademarks, or other proprietary rights
                    notices of ours or any third party;
                </p>
                <p>
                    3.6.5 use the personal information of another person in order to access or use the Website; and
                </p>
                <p>
                    3.6.6 transmit any bug, virus or other disabling feature to or through the Website.
                </p>
                <h2>4. ACCESSING AND USING OUR PLATFORM</h2>
                <p>
                    4.1 If you post or provide any information or content on or via the Platform, for example by
                    commenting on any public, private or group chats or message boards, you must ensure that such
                    information does not contravene any applicable laws or infringe any person's legal rights. We do not
                    monitor or edit information, content, documents or files posted or provided to us by users and third
                    parties and accordingly we do not accept any responsibility for any damage or loss you may suffer.
                </p>
                <p>
                    4.2 By submitting, posting or displaying information or content on or through the Platform, you
                    grant a non-exclusive, royalty-free, sub-licensable license without territorial limits to us. We may
                    use, copy, reproduce, process, adapt, modify, publish, transmit, display, and distribute such
                    information or content in any media or via distribution methods currently available or developed
                    later.
                </p>
                <p>
                    4.3 You acknowledge that the Platform does not include functionality of video and audio record,
                    however certain users can record video and audio of meetings, exhibitions, events, conferences or
                    interactions. You will be notified in the event that a meeting, event or conference is due to be
                    recorded. If you do not want to be included in any recording, please exit the relevant meeting,
                    exhibition, event or conference.
                </p>
                <p>
                    4.4 You agree that you will not:
                </p>
                <p>
                    4.4.1 use the Platform in any unlawful manner, for any unlawful purpose, or in any manner
                    inconsistent with these Terms, or act fraudulently or maliciously;
                </p>
                <p>
                    4.4.2 conceal or steal the identity of a third party or pretend to be or represent a third party
                    when using the Platform, unless expressly allowed to do so by such third party;
                </p>
                <p>
                    4.4.3 manipulate identifiers in order to disguise or otherwise conceal the origin of another user's
                    messages or of the content posted;
                </p>
                <p>
                    4.4.4 misappropriate any profile in use by another user of the Platform;
                </p>
                <p>
                    4.4.5 register on or use the Platform in order to approach our users to promote, sell or advertise
                    products or services of any kind;
                </p>
                <p>
                    4.4.6 not use the Platform or any Service in a way that could damage, disable, overburden, impair or
                    compromise our systems or security or interfere with other users; and
                </p>
                <p>
                    4.4.7 not collect or harvest any information or data from any Service or our systems or attempt to
                    decipher any transmissions to or from the servers running any Service;
                </p>
                <p>
                    4.4.8 disseminate or publish content that is unlawful, obscene, illegitimate, defamatory or
                    inappropriate; or
                </p>
                <p>
                    4.4.9 defame, abuse, harass, use threatening practices, threaten or violate the legal rights of
                    other users of the Platform.
                </p>
                <h2>5. KEEPING YOUR PROFILE SECURE</h2>
                <p>
                    5.1 Where you are provided with a user ID, password or any other piece of information as part of the
                    security procedures on our Services, you must treat such information as confidential and you must
                    not disclose it to any third party. The right to use the secure areas of the Services is personal to
                    you, and you may not allow other people to use your log-in details.
                </p>
                <p>
                    5.2 You are responsible for all activity and for the accuracy of all information and requests sent
                    using your username, password or any other personal identification implemented to identify you.
                </p>
                <p>
                    5.3 You must notify us immediately of any unauthorised use of your profile, or other account related
                    security breach of which you are aware.
                </p>
                <p>
                    5.4 If you inform us, or if we have reason to believe that, unauthorised use is being made of the
                    Services (whether by you or through your account) then, without prejudice to our other rights and
                    remedies, we may suspend or terminate your access to the secure areas of the Services immediately.
                </p>
                <h2>6. INTELLECTUAL PROPERTY RIGHTS</h2>
                <p>
                    6.1 We are the owner or the licensee of all intellectual property rights in our Services, and in the
                    material published on it. Those works are protected by copyright laws and treaties around the world.
                    All such rights are reserved.
                </p>
                <p>
                    6.2 You acknowledge that you have no intellectual property rights in, or to, the Services other than
                    the right to use the Services in accordance with these Terms.
                </p>
                <p>
                    6.3 You agree that you will not reproduce, copy, download, share (beyond the limits set forth
                    below), modify, publish, transmit, sell, sublicense, edit, transfer or assign to third parties or
                    create derivative works from the information or content (whether ours or of third parties),
                    available on the Services, nor allow any third party to do so. Notwithstanding the foregoing, where
                    explicitly stated on the Services, you may be authorised to reproduce, copy, download or share some
                    content or information available on the Services for your sole personal use and provided that the
                    copyright attributions and all the other attributions requested by us are correctly implemented.
                </p>
                <p>
                    6.4 If you wish to reproduce or use information from the Services beyond the terms of these Terms,
                    please contact us for express consent. You can do this by addressing your request to
                    <a href="mailto:info@pandamr.com">info@pandamr.com</a>.
                </p>
                <h2>7. LIABILITY</h2>
                <p>
                    7.1 We provide the Services on an "as is" and "as available" basis and to the fullest extent
                    permissible by law we do not guarantee that our Services will meet particular requirements, or be
                    available, accessible, uninterrupted, timely, secure or operate without error, or that it will be
                    free from viruses, worms, Trojans or other harmful elements. We recommend that you protect your
                    equipment by having appropriate anti-virus software in place.
                </p>
                <p>
                    7.2 Where our Website contains links to other sites and resources provided by third parties, these
                    links are provided for your information only. We have no control over the contents of those sites or
                    resources so we assume no responsibility for the content of such sites. Such links should not be
                    interpreted as endorsement by us of those linked websites. We will not be liable for any loss or
                    damage that may arise from your use of them.
                </p>
                <p>
                    7.3 To the extent permitted by law, we exclude all conditions, warranties, representations or other
                    Terms which may apply to our Services or any content on them, whether express or implied.
                </p>
                <p>
                    7.4 We will not be liable to any user for any of the following types of loss or damage, whether
                    arising in contract, tort (including negligence), breach of statutory duty, or otherwise, resulting
                    from or in connection with use of, or inability to use, our Services; or use of or reliance on any
                    content displayed on our Services:
                </p>
                <p>
                    7.4.1 loss of profits, sales, business, or revenue;
                </p>
                <p>
                    7.4.2 business interruption;
                </p>
                <p>
                    7.4.3 loss of anticipated savings;
                </p>
                <p>
                    7.4.4 loss of business opportunity, goodwill or reputation; or
                </p>
                <p>
                    7.4.5 any indirect or consequential loss or damage.
                </p>
                <p>
                    7.5 Nothing in these Terms is intended to exclude or limit for any liability that cannot be excluded
                    or limited by law. This includes liability for death or personal injury caused by our negligence or
                    the negligence of our employees, agents or subcontractors or for fraud or fraudulent
                    misrepresentation.
                </p>
                <h2>8. TERMINATION</h2>
                <p>
                    8.1 You can stop using the Services, and cancel your profile on the Platform, at any time.
                </p>
                <p>
                    8.2 We may terminate or suspend the Licence our your right to use the Platform immediately by
                    written notice to you if you commit a material or persistent breach of these Terms which you fail to
                    remedy (if remediable) within 14 days after the service of written notice requiring you to do so.
                </p>
                <p>
                    8.3 Upon termination for any reason:
                </p>
                <p>
                    8.3.1 all rights granted to you under the Licence shall cease;
                </p>
                <p>
                    8.3.2 you must cease all activities authorised by these Terms, including your use of the Platform;
                    and
                </p>
                <p>
                    8.3.3 you must immediately delete or remove the Software from all computer equipment in your
                    possession and immediately destroy or return to us (at our option) all copies of the Software then
                    in your possession, custody or control and, in the case of destruction, certify to us that you have
                    done so.
                </p>
            </div>
        </div>
    )
}

export default TermsOfConditions;
